module.exports = __webpack_public_path__ + "img/trinity_cool_anim.bbaaf7bf.gif";